'use client';
import ReactEcharts from 'echarts-for-react';

export const EChart = ({ chartOptions, height }: { chartOptions: any; height?: number | string }) => {
  const h = height ?? '100%';
  return (
    <div className="h-full w-full">
      <ReactEcharts
        option={chartOptions || {}}
        style={{
          height: h,
          width: '100%',
        }}
      />
    </div>
  );
};
